export default "/assets/images/rookie-parent2.904d7f15afa1e4d4.png";